export default __webpack_public_path__ + "static/media/biz_booking_icon_consultation.980d440a.svg";